import { Routes } from '@angular/router';

const title = 'Seguridad';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [
  {
    path: 'rol',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Roles' }] },
        loadComponent: () => import('./pages/rol-lista/rol-lista.component'),
      },
    ],
  },
];
